import React from "react";

// A bare number (e.g. 180 or "180") is shown as "180 Minutes"; values that already
// carry a unit (e.g. "90 Minutes", "3 Hours") are left as-is. Empty stays empty.
const formatTime = (t) => {
  if (t === undefined || t === null || String(t).trim() === "") return "";
  const s = String(t).trim();
  return /^\d+$/.test(s) ? `${s} Minutes` : s;
};

// Top section: centred university heading and the exam meta block.
const Header = ({ data }) => (
  <div className="qp-header">
    {data.university && <h1>{data.university}</h1>}
    {data.collegeName && <h3>{data.collegeName}</h3>}
    <h2>{data.examTitle}</h2>
    {(data.department || data.subjectCode || data.subjectName) && (
      <div className="qp-meta">
        {data.department && <div>{data.department}</div>}
        {data.subjectCode && <div>{data.subjectCode} - {data.subjectName}</div>}
      </div>
    )}
    {(data.regulation || data.semester || data.academicYear) && (
      <div className="qp-reg-sem">
        {data.regulation && <span>Regulation {data.regulation}</span>}
        {data.semester && <span>Semester {data.semester}</span>}
        {data.academicYear && <span>{data.academicYear}</span>}
      </div>
    )}



    <div className="qp-time-marks">
      <span><strong>Time:</strong> {formatTime(data.time)}</span>
      <span><strong>Maximum Marks:</strong> {data.maxMarks}</span>
    </div>
  </div>
);

export default Header;
